/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TimeseriesYAxisAnnotation
 */
export interface TimeseriesYAxisAnnotation {
    /**
     * 
     * @type {string}
     * @memberof TimeseriesYAxisAnnotation
     */
    label: string;
    /**
     * 
     * @type {number}
     * @memberof TimeseriesYAxisAnnotation
     */
    yValue: number;
    /**
     * 
     * @type {string}
     * @memberof TimeseriesYAxisAnnotation
     */
    color: string;
}

/**
 * Check if a given object implements the TimeseriesYAxisAnnotation interface.
 */
export function instanceOfTimeseriesYAxisAnnotation(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "label" in value;
    isInstance = isInstance && "yValue" in value;
    isInstance = isInstance && "color" in value;

    return isInstance;
}

export function TimeseriesYAxisAnnotationFromJSON(json: any): TimeseriesYAxisAnnotation {
    return TimeseriesYAxisAnnotationFromJSONTyped(json, false);
}

export function TimeseriesYAxisAnnotationFromJSONTyped(json: any, ignoreDiscriminator: boolean): TimeseriesYAxisAnnotation {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'label': json['label'],
        'yValue': json['yValue'],
        'color': json['color'],
    };
}

export function TimeseriesYAxisAnnotationToJSON(value?: TimeseriesYAxisAnnotation | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'label': value.label,
        'yValue': value.yValue,
        'color': value.color,
    };
}

